import React from 'react';
import { ModalAddToMarketplace } from 'new/elements/ModalAddToMarketplace/ModalAddToMarketplace';
import { useModals } from 'new/hooks/useModals';
import { useIsOrgFeatureEnabled } from 'new/hooks/adapters/useIsOrgFeatureEnabled';

interface WithModalsProps {
  handleOpenModal: (data: any) => void;
}

const withModals =
  <P extends object>(WrappedComponent: React.ComponentType<P & WithModalsProps>) =>
  (props: P) => {
    const { openModal } = useModals();
    const isMarketplaceEnabled = useIsOrgFeatureEnabled('marketplace');

    const handleOpenModal = (data: any) => {
      openModal(ModalAddToMarketplace.modalConfig.name, {
        ...props,
        item: data,
      });
    };

    return (
      <WrappedComponent
        {...props}
        handleOpenModal={handleOpenModal}
        isMarketplaceEnabled={isMarketplaceEnabled}
      />
    );
  };

export default withModals;
